export default __webpack_public_path__ + "static/media/A_05_04_bg_v02.c496140b.mp4";